export const isDevClient = process.env.REACT_APP_CLIENT_ENV === "development";

/** Floating Dev Tools FAB: local CRA only. Never on production/UAT/demo builds. */
export const showDevTools =
  process.env.NODE_ENV === "development" && isDevClient;

export const getApiBaseUrl = () =>
  process.env.REACT_APP_CLIENT_ENV === "development"
    ? process.env.REACT_APP_LOCAL_URL || "http://localhost:8000"
    : process.env.REACT_APP_SERVER_URL || "https://api.quest-q.com";
